import { INPUT_STYLES } from '../styles';

const setInitialStyles = () => {
  Spreedly.setStyle('number', INPUT_STYLES.default);
  Spreedly.setStyle('cvv', INPUT_STYLES.default);
};

const setPlaceholders = () => {
  Spreedly.setPlaceholder('number', 'XXXX XXXX XXXX XXXX');
  Spreedly.setPlaceholder('cvv', '123');
};

const setFieldTypes = () => {
  Spreedly.setFieldType('number', 'text');
  Spreedly.setFieldType('cvv', 'text');
  Spreedly.setNumberFormat('maskedFormat');
};

const enableSubmitButton = () => {
  const submitButton = document.getElementById(
    'submit-button'
  ) as HTMLButtonElement;
  if (!submitButton) return;
  submitButton.disabled = false;
};

const handleReady = () => {
  setFieldTypes();
  setInitialStyles();
  setPlaceholders();
  enableSubmitButton();
};

export default handleReady;
